/* src/app/subcontractor/pages/subcontractor-edit/subcontractor-edit.component.scss */
/*# sourceMappingURL=subcontractor-edit.component.css.map */
